"use client";
import Link from "@/components/MyLink";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";

import { BsArrowLeft } from "react-icons/bs";

export default function HeaderStatic({
  subTitle,
  children,
}: {
  subTitle?: string;
  children: ReactNode;
}) {
  const router = useRouter();

  return (
    <div className="drawer">
      <input id="drawer" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content">
        <div className="navbar px-0 flex items-center bg-base-300 flex-row w-full">
          <Link className="btn btn-ghost btn-circle" href="/">
            <BsArrowLeft className="text-xl text-white font-bold" />
          </Link>

          <div className="flex w-full justify-between">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-xl font-normal cursor-pointer max-w-[100%]">
                  {subTitle}
                </h2>
              </div>
              <div className="flex flex-end items-center" />
            </div>
          </div>
        </div>
        <div className="flex overflow-hidden h-[calc(100%-64px)] bg-base-200">
          {children}
        </div>
      </div>
    </div>
  );
}
